import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { href: "/", label: "Home" },
    { href: "/#chi-siamo", label: "Chi Siamo" },
    { href: "/#team", label: "Team" },
    { href: "/servizi", label: "Servizi" },
    { href: "/risorse", label: "Risorse" },
    { href: "/#partners", label: "Partners" },
    { href: "/contatti", label: "Contatti" },
  ];

  const handleNavClick = (href) => {
    setIsOpen(false);
    if (href.includes("#") && location.pathname === "/") {
      const element = document.getElementById(href.split("#")[1]);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  return (
    <nav
      className="backdrop-blur-md bg-white/90 border-b border-brand-border sticky top-0 z-50"
      data-testid="navbar"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link
            to="/"
            className="flex items-center gap-3"
            data-testid="navbar-logo"
          >
            <span className="font-heading text-2xl font-bold text-brand-primary">
              Metodo Contabile
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                onClick={() => handleNavClick(link.href)}
                className="nav-link text-brand-foreground hover:text-brand-primary font-medium transition-colors"
                data-testid={`nav-link-${link.label.toLowerCase().replace(" ", "-")}`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* CTA Button Desktop */}
          <div className="hidden md:block">
            <Link to="/contatti">
              <Button
                className="bg-brand-primary hover:bg-brand-primary-dark text-white rounded-full px-6"
                data-testid="navbar-cta-btn"
              >
                Richiedi Consulenza
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 text-brand-foreground"
            onClick={() => setIsOpen(!isOpen)}
            data-testid="mobile-menu-btn"
            aria-label="Toggle menu"
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div
            className="md:hidden py-4 border-t border-brand-border animate-fade-in"
            data-testid="mobile-menu"
          >
            <div className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  onClick={() => handleNavClick(link.href)}
                  className="text-brand-foreground hover:text-brand-primary font-medium py-2 transition-colors"
                  data-testid={`mobile-nav-link-${link.label.toLowerCase().replace(" ", "-")}`}
                >
                  {link.label}
                </Link>
              ))}
              <Link to="/contatti" onClick={() => setIsOpen(false)}>
                <Button
                  className="bg-brand-primary hover:bg-brand-primary-dark text-white rounded-full w-full mt-2"
                  data-testid="mobile-cta-btn"
                >
                  Richiedi Consulenza
                </Button>
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
